import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import metaTemplate from '../views/metaTemplate.vue'
import messageLogs from '../views/messageLogs.vue'
import messageAnalytics from '../views/messageAnalytics.vue'
import messageUserWise from '../views/messageUserWise.vue'
import messageUserPricing from '../views/messageUserPricing.vue'
import numberIntegration from '../views/numberIntegration.vue'
import numberMatLeads from '../views/numberMatLeads.vue'
import blockList from '../views/blockList.vue'
import contactGroup from '../views/contactGroup.vue'
import waOrders from '../views/waOrders.vue'
// import HelloWorld from "@/components/HelloWorld.vue";

const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
    routes: [
    {
      path: '/',
      name: 'login',
      component: LoginView,
      meta: {
        header: 0
      }
    },
    {
      path: '/home/:waId?',
      name: 'home',
      component: HomeView,
      meta: { requiresAuth: true }
    },
    {
      path: '/meta/template/:waId',
      name: 'meta-template',
      component: metaTemplate,
      meta: { requiresAuth: true }
    },
    {
      path: '/message/logs/:waId',
      name: 'message-logs',
      component: messageLogs,
      meta: { requiresAuth: true }
    },
    {
      path: '/message/analytics/:waId',
      name: 'message-analytics',
      component: messageAnalytics,
      meta: { requiresAuth: true }
    },
    {
      path: '/message/userWise/:waId',
      name: 'message-userWise',
      component: messageUserWise,
      meta: { requiresAuth: true }
    },
      {
      path: '/message/userPricing/:waId',
      name: 'message-userPricing',
      component: messageUserPricing,
      meta: { requiresAuth: true }
    },
    {
      path: '/number/integration/:waId?',
      name: 'number-integration',
      component: numberIntegration,
      meta: { requiresAuth: true }
    },
    {
      path: '/block/list/:waId?',
      name: 'block-list',
      component: blockList,
      meta: { requiresAuth: true }
    },
    {
      path: '/contact/group/:waId?',
      name: 'contact-group',
      component: contactGroup,
      meta: { requiresAuth: true }
    },
    {
      path: '/wa/orders/:waId?',
      name: 'wa-orders',
      component: waOrders,
      meta: { requiresAuth: true }
    },
    {
      path: '/wa/mat/leads/:waId?',
      name: 'wa-mat-leads',
      component: numberMatLeads,
      meta: { requiresAuth: true }
    },
    {
      path: '/bulk/message/:waId',
      name: 'bulk-message',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/bulkMessage.vue'),
      meta: { requiresAuth: false }
    },
      {
      path: '/msg91/bulk/message/:waId',
      name: 'msg91-bulk-message',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/msgBulkMessage.vue'),
      meta: { requiresAuth: false }
    }
  ]
})
// const NMPUSER = JSON.parse(localStorage.getItem('NMPUSER'))
// router.beforeEach((to, from, next) => {
//   // console.log(from)
//   // console.log(to)
//   if (localStorage.getItem('NMPUSER') && NMPUSER && Object.prototype.hasOwnProperty.call(NMPUSER, "token") && to.params.waId == NMPUSER.token) {
//     next();
//   } else {
//     localStorage.removeItem('NMPUSER')
//     router.push('/');
//   }
// })
export default router
